import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Dialog, ElevatedButton, TextButton, TextInput } from '@producer/ui-kit';

import { Step } from '../../../app/entities';

interface RenameStepModalProps {
  onCancel: () => void;
  step: Step;
}

export const RenameStepModal: React.FC<RenameStepModalProps> = ({ onCancel, step }) => {
  const [isLoading, setIsLoading] = useState(false);

  const schema = yup.object({
    name: yup
      .string()
      .max(32, 'Max 32 characters')
      .min(1, 'Min 1 characters')
      .required('Name is required'),
  });

  const { handleSubmit, control } = useForm({
    defaultValues: {
      name: step.name || '',
    },
    mode: 'onBlur',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (name: string) => {
    await step.update({ name });
  };

  const onHandleSubmit = async (values: any) => {
    if (!isLoading) {
      setIsLoading(true);

      await onSubmit(values.name);

      setIsLoading(false);
      onCancel();
    }
  };

  return (
    <Dialog
      title={'Rename step'}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="submit"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit(onHandleSubmit)}
          text="Update"
        />,
      ]}
    >
      <form onSubmit={handleSubmit(onHandleSubmit)}>
        <Controller
          control={control}
          name="name"
          render={({ field: { onChange, value, name, ref }, fieldState: { error } }) => (
            <TextInput
              ref={ref}
              value={value}
              name={name}
              onChange={onChange}
              label="Name"
              errorMessage={error?.message}
              required
            />
          )}
        />
      </form>
    </Dialog>
  );
};
